import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { NgModule, LOCALE_ID } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarConfig } from '@angular/material/snack-bar';

import { Adaptater, InfraServiceModule } from '@leandredev/common_ng_14';

import dayjs from 'dayjs';
import fr from 'dayjs/locale/fr';

import { environment } from 'src/environments/environment';

import { PendingInterceptorModule } from 'src/@fury/shared/loading-indicator/pending-interceptor.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LayoutModule } from './layout/layout.module';
import { CanDeactivateGuard } from './guards/pending-changes.guard';

import { FormChangeService } from './services/form-change/form-change.service';
import { AuthenticationService } from './services/authentication/authentication.service';
import { DepartmentService } from './services/department/department.service';
import { ClientService } from './services/client/client.service';
import { FileUploadService } from './services/file-upload/file-upload.service';
import { ActsService } from './services/acts/acts.service';
import { ApiService } from './services/api/api.service';
import { ProfileService } from './services/profile/profile.service';
import { CoreService } from './services/core/core.service';
import { SessionService } from './services/session/session.service';
import { SignInJwtService } from './services/signIn-jwt/signIn-jwt.service';
import { ProxyAdapterService } from './services/proxy-adapter/proxy-adapter.service';
import { TemplateActService } from './services/templateAct/templateAct.service';
import { FeaturesModules } from './modules/features.module';

registerLocaleData(localeFr, 'fr');
dayjs.locale(fr);

const paginator: MatPaginatorIntl = new MatPaginatorIntl();
paginator.itemsPerPageLabel = 'Elements par page :';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],

  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LayoutModule,
    PendingInterceptorModule,
    AppRoutingModule,
    InfraServiceModule.forRoot(environment),
    FeaturesModules
  ],
  providers: [
    CanDeactivateGuard,
    CoreService,
    ApiService,
    SignInJwtService,
    FormChangeService,
    AuthenticationService,
    DepartmentService,
    ClientService,
    FileUploadService,
    ActsService,
    TemplateActService,
    ProfileService,
    SessionService,
    {
      provide: Adaptater,
      useClass: ProxyAdapterService
    },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'fill'
      } as MatFormFieldDefaultOptions
    },
    { provide: MatPaginatorIntl, useValue: paginator },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 5000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom'
      } as MatSnackBarConfig
    },

    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } }
  ]
})
export class AppModule {}
